import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ArrayResponse} from '../models/array-response';
import {SendBackResult} from '../models/send-back-result';
import {Timezone} from '../models/timezone';

import {AppSettingsService} from './app-settings.service';
import {BaseRestService} from './base-rest.service';
import {BlockUIService} from './block-ui.service';

@Injectable()
export class ClientConfigurationService extends BaseRestService {
  constructor(http: HttpClient, appSettingsService: AppSettingsService, blockUIService: BlockUIService) { super(http, appSettingsService, blockUIService); }

  protected get className(): string { return 'ClientConfigurationService'; }

  protected get isAnonymous(): boolean { return false; }

  getList(clientId: string): Observable<SendBackResult<ArrayResponse<any>>> { return this.get<ArrayResponse<any>>(`/client/${clientId}/Configurations`); }
}
